<template>
  <div class="about-container">
    <v-layout column align-center justify-center>
      <div class="about">
        <div class="mb-2 text-xs-center">
          <h1 class="juliazhao">Julia Zhao</h1>
          <span>DRE #01411270<br />RE/MAX Elite Realty</span>
        </div>
        <div style="display: block">
          <div class="about-photo">
            <v-avatar size="120">
              <v-img :src="require('@/assets/img/juliazhao.png')"></v-img>
            </v-avatar>
          </div>
          <div class="achievement-education">
            <h4>RE/MAX 2023年加州排名第13</h4>
            <h4>RE/MAX 2023年全美排名第41</h4>
            <h4>RE/MAX 传奇大奖</h4>
            <h4>RE/MAX全球排行前1%位</h4>
            <h4>RE/MAX终身成就奖</h4>
            <h4>RE/MAX Titan俱乐部大奖得主(RE/MAX全美排名前0.5%)</h4>
            <h4>计算机硕士学位</h4>
            <h4>政治学硕士学位</h4>
          </div>
        </div>
        <div>
          <div>
            <p>
              Julia Zhao&nbsp;是洛杉矶San Gabriel
              Valley最受客户信赖、也是最成功的房地产经纪人之一。她十多年来专注的业务地区包括Alhambra,
              Arcadia, San Marino, Monterey Park, San Gabriel, Temple City,
              Pasadena, South Pasadena。
            </p>
            <p>
              她的高等教育背景、广泛深厚的房地产业务经验、流利的中文和英文交流能力赢得了众多客户在买房及卖房过程中的高度满意。
            </p>
            <p>
              她的勤奋、细心和沟通能力使得每位客户都体验到一个轻松、满意的房地产交易。
            </p>
            <p>
              她对房地产市场的了解和观察敏锐使得她能够评估出合适的价格并因此促成快速交易。多年合作形成的专业团队为每个房产进行精美个性包装，因此常常获得多个买方出价，使得房产能以高于预期的价格售出。
            </p>
            <p>
              对于Julia来说房子卖完了不等于服务的结束，她和她的团队也是客户售后的可靠帮手。Julia很高兴也很自豪常常能为老客户再次特供服务。
            </p>
          </div>
          <div class="pt-4 pb-3">
            <div class="text-xs-center juliazhao">销售成就奖</div>
            <ul>
              <li>RE/MAX 2023年加州排名第13</li>
              <li>RE/MAX 2023年全美排名第41</li>
              <li>RE/MAX 传奇大奖</li>
              <li>RE/MAX 全美百强经纪人第37 (2017年1至8月)</li>
              <li>RE/MAX 全美百强经纪人第35 (2016年1至3月)</li>
              <li>RE/MAX 全美百强经纪人第77 (2015年1至5月)</li>
              <li>RE/MAX 终身成就奖 (自2014年)</li>
              <li>
                RE/MAX Titan俱乐部大奖 (RE/MAX全球排名前0.5%经纪人 2016-2017年)
              </li>
              <li>
                RE/MAX Chairman俱乐部大奖 (RE/MAX全球排名前1% 2010,
                2012-2015及2018年)
              </li>
              <li>
                RE/MAX 白金大奖 (RE/MAX全球排名前2%经纪人2008-2009及2011年)
              </li>
              <li>洛杉矶5星房地产经纪人获得者(2012-2018年)</li>
              <li>
                美国专业人士学会的加利福尼亚10佳房地产经纪人提名 (2015-2018年)
              </li>
            </ul>
          </div>
          <!--<div class="pt-4 pb-3">-->
          <!--<div class="text-xs-center juliazhao">Education</div>-->
          <!--<ul>-->
          <!--<li>Master of Science (Computer Science), Azusa University</li>-->
          <!--<li>Master of Art, (Political Science), Fudan University</li>-->
          <!--<li>Bachelor of Art ( Sociology ), Shanghai Univerisity</li>-->
          <!--</ul>-->
          <!--</div>-->
          <div class="pt-4 pb-5 julia-team">
            <div class="text-xs-center juliazhao">团队</div>
            <v-list two-line>
              <v-list-item>
                <v-list-item-avatar size="80">
                  <img :src="require('@/assets/img/diana.jpg')" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Diana Rios</v-list-item-title>
                  <v-list-item-subtitle>豪华室内设计师</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar size="80">
                  <img :src="require('@/assets/img/Tiana.jpg')" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Tiana Vitrano Saran</v-list-item-title>
                  <v-list-item-subtitle>室内设计师</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar size="80">
                  <img :src="require('@/assets/img/Kam.jpg')" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Kam Saran</v-list-item-title>
                  <v-list-item-subtitle>室内设计师</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar size="80">
                  <img :src="require('@/assets/img/nick.jpg')" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Nick Li</v-list-item-title>
                  <v-list-item-subtitle>专业摄影师</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </div>
        <!-- <v-divider light></v-divider>
          <div style="max-width:400px;"><achievements></achievements></div> -->
      </div>
    </v-layout>
    <!--<div v-if="!isMobile" v-bind:class="{'desktop':!isMobile}" style="position: absolute;max-width:400px;top: 2px;">-->
    <!--<achievements></achievements>-->
    <!--</div>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
// import Achievements from '../../components/Achievements'

export default {
  name: "about",
  components: {
    // Achievements
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.homeStore.isMobile,
    }),
  },
};
</script>

<style scoped>
@import "../about.css";
</style>
